import React from 'react';
import withRoot from './modules/withRoot';
import { UI_BASE_URL } from './consts';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';
import ExamResult from './modules/components/ExamResult';
import { langProps } from './interfaces/types';


const Page = () => (
    <React.Fragment>
        <AppAppBar />
        <ExamResult />
        <AppFooter />
    </React.Fragment>
);

export default withRoot(Page);

// Exam Resultの内容からはじめる

// どんな結果が必要かの考察
// 1. まずは、直近というか各々のテスト結果の分析がほしいはず
// なんていううんだろ六角形的な視覚的な全部の結果を出すのと（母音と子音でわけてもいいかも？）
// あとは、Certificate的な文言でTOEICの結果的に
// 日付と、将来的にはなんかリンクでつぶやいてもらえるような感じかな
// ここは先生視点でみたときにアドバイスができるようにするのがいいのと
// できれば、そのテストの練習ページにいけるよいよね（やりすぎだけど）
// ユーザネームと簡単なアイコンも左にだしたいかもね
// あと総合スコアか
//     あとはL Capitalのロゴも出したいねどっかに

// あとは間違った設問の一覧を出した方がいいかも


// 2. でも、トレンド的な分析結果もほしいはず
// おそらくデフォルトだと直近xxヶ月的なトレンドを示す感じにして
// とはいえ、xxは選べるようにすべきかな、、、それだとAPIを作らなきゃなので若干だるいが、
// - 総合スコアの推移は出すべきかな
//     - あとは苦手な設問の一覧（ここはトップ10とかに絞って出すのがよいか？先生が指示しやすいし

// Lets say that you have to propose a page design of English pronauniciate test result page of a website(constraint, you have to show the each test run and also historical test run statistics.

// Could you provide comprehensive items that the page should include so that users can improve their pronunciation better in the future
// ChatGPT:
//         ChatGPT

//     1. Overview Section
// Test Title: Clearly display the name of the test(e.g., "English Pronunciation Test").
// Overall Score: Show a summary score or percentage, e.g., "85% Accurate".
// Date and Time: Include when the test was taken for reference.
// 2. Detailed Results for the Test Run
// Per - Word Breakdown:
// A table or list showing:
// Words tested
// User's pronunciation status (Correct/Incorrect/Needs Improvement)
// A playback button for the user's pronunciation (so they can hear their attempt).
// A comparison playback button with the correct pronunciation.
// Phonetic Feedback: Highlight specific phonemes where the user struggled.
//     Tips: Context - specific tips for problematic words(e.g., "Focus on 'th' sound in 'thought'").
// Audio Visualization:
// Display waveforms or spectrograms comparing the user's pronunciation and the correct pronunciation.
// 3. Historical Statistics Section
// Recent Test History:
// Show recent test attempts with summary scores.
// Link to detailed results of previous attempts.
// Trend Visualization:
// A line graph or bar chart showing improvement over time(e.g., average scores per test, phoneme accuracy trends).
// Top Problem Areas:
// Highlight consistently problematic sounds, words, or patterns across test attempts.
// 4. Suggestions for Improvement
// Personalized Learning Path:
// Recommend specific exercises, such as tongue twisters or sound drills, based on weaknesses.
// Practice Goals:
// Suggest daily / weekly improvement targets.
// Relevant Resources:
// Links to videos, articles, or exercises to practice sounds or patterns the user struggles with.
// 5. Interactive Features
// Playback and Recording Tool:
// Allow users to retry and record their pronunciation for comparison directly on the results page.
// Word Favorites:
// Option to bookmark words they want to practice later.
// Feedback Option:
// Enable users to report issues or ask for clarification on specific words or feedback.
// 6. Social and Sharing Options
// Achievement Badges:
// Award badges for milestones(e.g., “First Test Completed,” “90 % Accuracy Achieved”).
//     Sharing:
// Allow users to share their progress on social media or with friends.
// 7. Other Considerations
// Language Accent Selector:
// Allow users to select the target accent for the test(e.g., American, British, Australian).
// Accessibility Features:
// Include text - based descriptions of audio feedback for users with hearing impairments.
// Mobile Responsiveness:
// Ensure that the design adapts well to smaller screens with touch - friendly controls.

